<script setup lang="ts">
const props = defineProps({
  id: String,
  disabled: Boolean
})
const model = defineModel()
</script>

<template>
  <label
      :for="id"
      class="w-[18px] h-[18px] rounded flex items-center justify-center cursor-pointer"
      :class="{ 'bg-primary-green' : model, 'border border-secondary-600' : !model }"
  >
    <svg v-if="model" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3617 3.18692C12.5895 3.41473 12.5895 3.78407 12.3617 4.01188L5.80331 10.5703C5.55272 10.8209 5.14644 10.8209 4.89586 10.5703L1.63727 7.31171C1.40947 7.0839 1.40947 6.71456 1.63727 6.48675C1.86508 6.25894 2.23442 6.25895 2.46223 6.48675L5.34958 9.3741L11.5368 3.18692C11.7646 2.95911 12.1339 2.95911 12.3617 3.18692Z" fill="white"/>
    </svg>
    <input :id type="checkbox" class="hidden" :disabled v-model="model">
  </label>
</template>

<style scoped>

</style>